import { Anchor, Badge, Box, Card, Checkbox, Group, Text } from '@mantine/core'
import type { Price } from 'api/dto/price'

interface AddonCardProps {
  addon: Price
  isSelected: boolean
  onToggle: () => void
  t: (key: string) => string
}

export function AddonCard({ addon, isSelected, onToggle, t }: AddonCardProps) {
  const isSoldOut = addon.isSoldOut

  return (
    <Card
      padding="sm"
      radius="md"
      sx={{
        border: isSelected ? '2px solid #850014' : '1px solid #e5e7eb',
        background: isSelected ? 'rgba(133, 0, 20, 0.03)' : '#fff',
        opacity: isSoldOut ? 0.6 : 1,
        transition: 'all 0.2s ease',
      }}
    >
      <Group position="apart" noWrap>
        <Group spacing="sm" noWrap sx={{ flex: 1 }}>
          <Checkbox
            checked={isSelected}
            onChange={isSoldOut ? undefined : onToggle}
            disabled={isSoldOut}
            color="red"
            styles={{
              input: {
                cursor: isSoldOut ? 'not-allowed' : 'pointer',
                '&:checked': { background: '#850014', borderColor: '#850014' },
              },
            }}
          />
          <Box sx={{ flex: 1 }}>
            <Group spacing={8} mb={2}>
              <Text weight={500} size="sm" color="#111827">
                {addon.name}
              </Text>
              {isSoldOut && (
                <Badge size="xs" color="red" variant="filled">
                  {t('register.sold-out')}
                </Badge>
              )}
            </Group>
            {addon.description && (
              <Text size="xs" color="dimmed" lineClamp={1}>
                {addon.description}
              </Text>
            )}
          </Box>
        </Group>
        {addon.waitingListUrl && isSoldOut && (
          <Anchor size="xs" color="red" href={addon.waitingListUrl} target="_blank">
            {t('register.waiting-list')}
          </Anchor>
        )}
      </Group>
    </Card>
  )
}
